import { CameraOutlined } from "@ant-design/icons";
import { message, Spin } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Urls, {
  postRequest,
} from "../../../../../services/common/urls";
import lang from "../../../../../services/lang";
import "./CustomerImageUploader.css";
function CustomerImageUploader(props) {
  const { langIndex } = useSelector((x) => x.app);
  const { user_picture, updateImage } = props;
  const [imageUrl, setImageUrl] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setImageUrl(user_picture);
  }, [user_picture]);

  const onDropImage = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }

    const file = files[0];
    // Validate file type
    const validTypes = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      message.error(lang(langIndex, "msg_something_wrong") + " - Invalid file type. Please select PNG, GIF, or JPEG image.");
      return;
    }

    // Validate file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      message.error(lang(langIndex, "msg_something_wrong") + " - File size too large. Maximum size is 5MB.");
      return;
    }

    setIsUploading(true);
    var formData = new FormData();
    formData.append("file", file);
    
    postRequest(Urls.UPLOAD_FACTORY_IMAGE, formData, (response) => {
      setIsUploading(false);
      
      if (response === null) {
        message.error(lang(langIndex, "msg_something_wrong") + " - Network error or server unavailable.");
        return;
      }
      
      if (response.status === true) {
        setImageUrl(response.url);
        updateImage(response.url);
        message.success("Logo uploaded successfully");
      } else {
        const errorMsg = response.message || lang(langIndex, "msg_something_wrong");
        message.error(errorMsg);
      }
    });
    
    // Reset input value to allow selecting the same file again
    e.target.value = "";
  };

  return (
    <Spin spinning={isUploading}>
      <div className="customer-logo-container">
        <img src={imageUrl} className="customer-logo-style" alt="Customer Logo" />
        <label htmlFor="upload_customer_image">
          <CameraOutlined className="customer-logo-add-button-style" size={50} />
          <input
            type="file"
            id="upload_customer_image"
            name="upload_customer_image"
            style={{ display: "none" }}
            accept="image/x-png,image/gif,image/jpeg,image/jpg"
            onChange={onDropImage}
            disabled={isUploading}
          />
        </label>
      </div>
    </Spin>
  );
}

export default CustomerImageUploader;
